import React, { useState } from "react";
import { Document, Page, Text, View, StyleSheet } from "@react-pdf/renderer";

const styles = StyleSheet.create({
  page: {
    paddingTop: 35,
    paddingLeft: 10,
    paddingRight: 10,
    paddingBottom: 20,
  },
  header: {
    textAlign: "center",
    fontSize: 16,
    marginBottom: 10,
    fontWeight: "bold",
  },
  subHeader: {
    textAlign: "center",
    fontSize: 12,
    marginBottom: 5,
  },
  section: {
    marginBottom: 10,
    flexDirection: "row",
    justifyContent: "flex-start", // Align content to the left and right
  },
  sectionTitle: {
    fontSize: 12,
    marginBottom: 5,
    width: "30%",
    textAlign: "left", // Align section title to the left
    paddingLeft: 10, // Optional padding for better alignment with arrow
  },
  sectionContent: {
    fontSize: 10,
    marginBottom: 5,
    width: "70%",
    maxWidth: "100%",
    textAlign: "left",
    paddingRight: 10,
    overflowWrap: "break-word",
    wordBreak: "break-word",
  },
  line: {
    borderBottom: "1px solid black",
    marginBottom: 10,
  },
  pageNumber: {
    fontSize: 10,
    textAlign: "right",
    position: "absolute",
    right: 10,
    bottom: 10, // Page number at the bottom-right corner
  },
  pageNumberTop: {
    fontSize: 10,
    textAlign: "right",
    position: "absolute",
    right: 10,
    top: 10, // Page number at the top-right corner
  },
});

const generateAdminRemedyPDF = ({
  inmateName,
  inmateId,
  adminRemedyData,
  title,
}) => {
  // 👇 Helper function to render header section on every page
  const renderHeader = () => (
    <View style={styles.subHeader} fixed>
      <Text>Inmate Inbox</Text>
      <View style={styles.header}>
        <Text>{title}</Text>
      </View>
      <View style={styles.section}>
        <Text style={[styles.sectionTitle, { color: "orange" }]}>
          Inmate Name:
        </Text>
        <Text style={[styles.sectionContent, { color: "orange" }]}>
          {inmateName || "-"}
        </Text>
      </View>

      <View style={styles.section}>
        <Text style={[styles.sectionTitle, { color: "orange" }]}>
          Resident ID:
        </Text>
        <Text style={[styles.sectionContent, { color: "orange" }]}>
          {inmateId || "-"}
        </Text>
      </View>

      <View style={styles.line}></View>
    </View>
  );

  const maxLength = 50; // Set max length for each line of text

  // Function to split text based on max length
  // const splitText = (text, maxLength) => {
  //   let result = [];
  //   let start = 0;
  //   while (start < text.length) {
  //     result.push(text.substring(start, start + maxLength));
  //     start += maxLength;
  //   }
  //   return result;
  // };

  return (
    <Document>
      {adminRemedyData?.map((form, index) => (
        <Page style={styles.page} key={index}>
          {/* Render header at the top of every page */}
          {renderHeader()}

          {/* Remedy Form */}
          <Text style={[styles.sectionTitle, { fontWeight: "bold" }]}>
            Remedy Form {index + 1}
          </Text>
          <View style={styles.section}>
            <Text style={styles.sectionTitle}>POD</Text>
            <Text style={styles.sectionContent}>{form.POD || "N/A"}</Text>
          </View>

          {/* Grievance Info */}
          <View style={styles.section}>
            <Text style={[styles.sectionTitle, { fontWeight: "bold" }]}>
              Grievance Info
            </Text>
          </View>
          <View style={styles.section}>
            <Text style={[styles.sectionTitle]}>Grievance</Text>
            <Text style={styles.sectionContent}>{form.Grievance || "N/A"}</Text>
          </View>

          <View style={styles.section}>
            <Text style={styles.sectionTitle}>Description</Text>
            <Text style={styles.sectionContent}>
              {form.Description || "N/A"}
            </Text>
          </View>

          {/* Example of Description field */}
          {/* <View style={styles.section}>
            <Text style={styles.sectionTitle}>Description</Text>
            {splitText(form.Description || "N/A", maxLength).map((line, i) => (
              <Text key={i} style={styles.sectionContent}>
                {line}
              </Text>
            ))}
          </View> */}

          {/* Other Sections */}
          <View style={styles.section}>
            <Text style={styles.sectionTitle}>Received By</Text>
            <Text style={styles.sectionContent}>
              {form.ReceivedBy || "N/A"}
            </Text>
          </View>

          <View style={styles.section}>
            <Text style={styles.sectionTitle}>Date Received</Text>
            <Text style={styles.sectionContent}>
              {form.DateReceived || "N/A"}
            </Text>
          </View>

          <View style={styles.section}>
            <Text style={styles.sectionTitle}>Forwarded</Text>
            <Text style={styles.sectionContent}>{form.Forwarded || "N/A"}</Text>
          </View>

          {/* Investigation Info */}
          <View style={styles.section}>
            <Text style={[styles.sectionTitle, { fontWeight: "bold" }]}>
              Investigation Info
            </Text>
          </View>
          <View style={styles.section}>
            <Text style={[styles.sectionTitle]}>Investigation</Text>
            <Text style={styles.sectionContent}>
              {form.Investigation || "N/A"}
            </Text>
          </View>

          <View style={styles.section}>
            <Text style={styles.sectionTitle}>Completed By</Text>
            <Text style={styles.sectionContent}>
              {form.CompletedBy || "N/A"}
            </Text>
          </View>

          {/* Review Findings Info */}
          <View style={styles.section}>
            <Text style={[styles.sectionTitle, { fontWeight: "bold" }]}>
              Review Findings Info
            </Text>
          </View>

          <View style={styles.section}>
            <Text style={[styles.sectionTitle]}>Review Findings</Text>
            <Text style={styles.sectionContent}>
              {form.ReviewFindings || "N/A"}
            </Text>
          </View>

          <View style={styles.section}>
            <Text style={styles.sectionTitle}>Date</Text>
            <Text style={styles.sectionContent}>{form.Date || "N/A"}</Text>
          </View>

          <View style={styles.section}>
            <Text style={styles.sectionTitle}>Supervisor Signature</Text>
            <Text style={styles.sectionContent}>
              {form.SupervisorSignature || "N/A"}
            </Text>
          </View>

          <View style={styles.section}>
            <Text style={styles.sectionTitle}>Supervisor Title</Text>
            <Text style={styles.sectionContent}>
              {form.SupervisorTitle || "N/A"}
            </Text>
          </View>

          {/* Page Number at Bottom */}
          <Text
            style={[styles.pageNumberTop]}
            render={({ pageNumber, totalPages }) =>
              `Page ${pageNumber} of ${totalPages}`
            }
            fixed
          />
          <Text
            style={[styles.pageNumber]}
            render={({ pageNumber, totalPages }) =>
              `Page ${pageNumber} of ${totalPages}`
            }
            fixed
          />
        </Page>
      ))}
    </Document>
  );
};

export default generateAdminRemedyPDF;
